import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSomewhatSatisfied",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], h = ["id"];
function p(e, t, r, _, g, i) {
  return n(), s("svg", {
    "aria-label": r.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--somewhat-satisfied"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Somewhat Satisfied",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M5.899 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.399 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm3.5-1.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5ZM3.353 7.196a.5.5 0 0 1 .7-.093l.083.063-.303.397.303-.397c.284.217.63.334.987.334h1.508c.38 0 .747-.133 1.039-.376l.32.385-.32-.385.01-.008a.5.5 0 1 1 .64.768l-.01.01a2.625 2.625 0 0 1-1.68.606H5.124c-.576 0-1.136-.19-1.594-.54l-.083-.063a.5.5 0 0 1-.093-.7Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, m);
}
const b = /* @__PURE__ */ u(c, [["render", p]]);
export {
  b as default
};
//# sourceMappingURL=somewhat-satisfied.js.map
